export default __webpack_public_path__ + "static/media/Photoshop.f5cba544.png";